import React from "react";
import { alpha, Box, ListItemButton, ListItemText } from "@mui/material";
import { buildTargetUrl, isExactMatch } from "./utils";

/** First level of nested element */
export const SubItem = ({ child, open, level, navigate, location, theme }) => {
  const showBullet = level > 1;

  // Matches the selected filter URL
  const active = isExactMatch(
    location,
    child.segment,
    child.query,
    child.activeMatch
  );

  return (
    <ListItemButton
      onClick={() => navigate(buildTargetUrl(child.segment, child.query))}
      selected={false}
      sx={{
        height: 33,
        justifyContent: "initial",
        mx: 0.3,
        py: 0,
        borderRadius: 2,
        mb: 0.25,
        boxShadow: active && `0 0 4px -2px ${theme.palette.blueGray200.main}`,
        bgcolor: active && alpha(theme.palette.common.white, 0.9),
      }}
    >
      {showBullet && (
        <Box
          sx={{
            width: 4,
            height: 4,
            mr: 0.3,
            borderRadius: "50%",
            bgcolor: active
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
            flexShrink: 0,
          }}
        />
      )}
      <ListItemText
        primary={open ? child.title : ""}
        primaryTypographyProps={{
          opacity: open ? 1 : 0,
          fontWeight: 600,
          color: active ? "primary" : "secondary",
          fontSize: 11.5,
          mx: 0.5,
          sx: {
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
          },
        }}
      />
    </ListItemButton>
  );
};
